import {
    IQuestionnaireSection, IQuestionnaireSubSection, IConditionalOptions,
    EnumSectionType, EnumCAMTherapieName, GenereateCAMRes, GenereateCAMEndRes,
    EnumQuestionType, EnumFreeTextType, EnumInputSize, EmptyAnswer, ISymptomeName,
    EnumMedikamentName, GenereateMedikamentRes, GenereateNichtRes, emailPattern
} from './questionnaire.model';

export const categoryOptions: string[] = [
    "Cannabis extract",
    "Dronabinol",
    "Cannabis flowers",
    "Sativex",
    "Cesamet",
    "Capsules",
    "Other"
]

export const freeTextInput = "Other, Free text";
export const KeineNebenwirkungen_EN = "No side effects";

export const CamTherapieSecondSubSection_EN: IQuestionnaireSubSection = {
    number: 2,
    title: "Information on medical cannabis products used within the context of the indication at the time of observation of the case study",
    description: `When it comes to dosage (daily requirement), either the total daily requirement can be specified or according to the scheme "morning - noon - evening" (e.g. when applied in milliliters: 0.3 - 0.3 - 0.5.`,
    questions: [],
    sectionType: EnumSectionType.CAMTHERAPIE,
    therapieObj: {
        therapieName: EnumCAMTherapieName.CAMTherapie,
        addMore: "other MC's",
        required: true,
        responseData: [GenereateCAMRes()],
        category: {
            label: "Type of medical cannabis",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: categoryOptions
        },
        product: {
            label: "Exact name",
            inputType: EnumQuestionType.INPUT,
            required: false,
            hidden: true,
            options: [],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        },
        startDate: {
            label: "Start of therapy",
            inputType: EnumQuestionType.MONTH,
            required: true
        },
        phaseDuration: {
            label: "Duration of titration Phase in weeks",
            inputType: EnumQuestionType.INPUT,
            required: true
        },
        applicationUnit: {
            label: "Application form/unit",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: [],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        },
        dailyDosage: {
            label: "Dosage (in total daily)",
            inputType: EnumQuestionType.INPUT,
            required: true
        },
        remarks: {
            label: "Comments",
            inputType: EnumQuestionType.INPUT,
            placeholder: "Special considerations, e.g., regarding the dosage or type of the medical cannabis."
        }
    }
}

export const CamTherapieFourthSubSection_EN: IQuestionnaireSubSection = {
    number: 4,
    title: "Please list medical cannabis that have been discontinued.",
    questions: [],
    sectionType: EnumSectionType.CAMTHERAPIE,
    therapieObj: {
        therapieName: EnumCAMTherapieName.CAMTherapieEnd,
        addMore: "other MC's",
        required: true,
        responseData: [GenereateCAMEndRes()],
        category: {
            label: "Type of medical cannabis",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: categoryOptions
        },
        product: {
            label: "Exact name",
            inputType: EnumQuestionType.INPUT,
            required: false,
            hidden: true,
            options: [],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        },
        startDate: {
            label: "Start of therapy",
            inputType: EnumQuestionType.MONTH,
            required: true
        },
        endDate: {
            label: "End of therapy",
            inputType: EnumQuestionType.MONTH,
            required: true
        },
        applicationUnit: {
            label: "Application form/unit",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: [],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        },
        dailyDosage: {
            label: "Dosage at the end of therapy (in total daily)",
            inputType: EnumQuestionType.INPUT,
            required: true
        },
        remarks: {
            label: "Reason",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: [
                "Intolerable side effects",
                "Insufficient symptom relief after titration phase",
                "Therapy costs were not covered by the health insurance",
                "Medical cannabis product not available",
                "Switch to another MC",
                "Other reason (free text)"
            ],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        }
    }
}

export const IndikationOptions: IConditionalOptions[] = [
    {
        label: "Pain",
        options: [
            "Persistent somatoform pain disorder (F45.40)",
            "Chronic pain disorder with somatic and psychological factors (F45.41)",
            "Cluster headache syndrome (G44.0)",
            "Endometriosis (N94/N80)",
            "Fibromyalgia (M79.7)",
            "Joint pain (M25)",
            "Malignant disease with tumor pain (R52.1)",
            "Migraine (G43)",
            "Muscle pain (M79.1)",
            "Rheumatical pain (M79.0)",
            "Back pain (M54)",
            "Musculoskeletal pain (M25)",
            "Tension-type headache (G44.2)",
            "Cancer pain (R52.1)",
            freeTextInput
        ]
    },
    {
        label: "Spasticity",
        options: [
            "Muscle cramps and spasms (R25.2)",
            "Parkinson's disease (G20)",
            "Multiple sclerosis (G35)",
            "Spastic paraparesis/tetraparesis and Paraplegia/Tetraplegia (G82)",
            "Other specified diseases of the spinal cord (G95.83)",
            freeTextInput
        ]
    },
    {
        label: "Neurological disorder",
        options: [
            "CFS (R53/G93.3)",
            "Cluster headache syndrome (G44.0)",
            "Epilepsy (G40)",
            "Migraine (G43)",
            "Parkinson's disease (G20)",
            "Multiple sclerosis (G35)",
            "Neuropathic pain (G56-63)",
            "Restless legs syndrome (G25.81)",
            "Sleep disorder (G47)",
            "Tension-type headache (G44.2)",
            "Spastic paraplegia/tetraplegia and paraplegia/tetraplegia (G82)",
            "Other specified diseases of the spinal cord (G95.83)",
            freeTextInput
        ]
    },
    {
        label: "Psychiatric disorder",
        options: [
            "Attention-deficit hyperactivity disorder (F90)",
            "Anxiety disorder (F41)",
            "Persistent somatoform pain disorder (F45.40)",
            "Chronic pain disorder with somatic and psychological factors (F45.41)",
            "Depression (F32)",
            "Post-traumatic stress disorder (F43.1)",
            "Tourette syndrome (F95)",
            freeTextInput
        ]
    },
    {
        label: "Cancer",
        options: [
            "Anxiety disorder in malignant disease (F41)",
            "Loss of appetite in malignant disease (R63)",
            "Depression in malignant disease (F32)",
            "Cachexia in malignant disease (R64)",
            "Malignant disease with cancer pain (R52.1)",
            "Sleep disorder in malignant disease (G47)",
            "Cancer pain (R52.1)",
            "Nausea and vomiting during chemotherapy (Y57.9!)",
            "Nausea and/or vomiting (R11)",
            freeTextInput
        ]
    },
    {
        label: "Gastrointestinal disorder",
        options: [
            "Ulcerative colitis (K51)",
            "Cachexia (R64)",
            "Crohn's disease (K50)",
            "Irritable bowel syndrome (K58)",
            "Nausea and/or vomiting (R11)",
            freeTextInput
        ]
    },
    {
        label: "Other",
        options: [
            "CFS (R53/G93.3)",
            "Endometriosis (N94/N80)",
            "Cachexia (R64)",
            "Sleep disorder (G47)",
            "Nausea and/or vomiting (R11)",
            freeTextInput
        ]
    }
]

export const NebenwirkungenSecondSubSection_EN: IQuestionnaireSubSection = {
    number: 2,
    title: "Impact on quality of life",
    description: `Please indicate how strongly each of the side effects you have indicated negatively affects the quality of life.<br/>
    (0 = <strong>no negative impact</strong> on quality of life - 10 = <strong>most severe negative impact</strong> on quality of life)`,
    sectionType: EnumSectionType.SYMPTOMES,
    symptomeObj: {
        dependedToThis: ISymptomeName.NebenwirkungenAuswahl,
        symptomes: []
    },
    questions: []
}

export const QuestionnaireJSON_EN: IQuestionnaireSection[] = [
    {
        number: 1,
        stepper: 'Specialty',
        title: 'Personal Information',
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "Specialty",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["General Medicine", "Anesthesiology", "Gynecology", "Internal Medicine", "Neurology", "Orthopedics and Trauma Surgery", "Physical and Rehabilitation Medicine", "Psychiatry and Psychotherapy", freeTextInput]
                    },
                    {
                        number: 2,
                        title: "Federal State",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Baden-Württemberg", "Bayern", "Berlin", "Brandenburg", "Bremen", "Hamburg", "Hessen", "Mecklenburg-Vorpommern", "Niedersachsen", "Nordrhein-Westfalen", "Rheinland-Pfalz", "Saarland", "Sachsen", "Sachsen-Anhalt", "Schleswig-Holstein", "Thüringen", freeTextInput]
                    }
                ]
            }
        ]
    },
    {
        number: 2,
        stepper: "Patient Information",
        title: "Patient Information",
        infoText: "*Voluntary information",
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "What is the treatment status? The patient...",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["is currently receiving treatment from you", "was treated by you in the past"]
                    },
                    {
                        number: 2,
                        title: "Time of review of the case (observation date, e.g., treatment termination)",
                        placeholder: "Month/Year",
                        inputType: EnumQuestionType.MONTH,
                        inputSize: EnumInputSize.MEDIUM,
                        hidden: true,
                        required: false,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 3,
                        title: "Year of birth",
                        inputType: EnumQuestionType.INPUT,
                        questSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 4,
                        title: "Body weight in kilograms*",
                        inputType: EnumQuestionType.INPUT,
                        questSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 5,
                        title: "Height in centimeters*",
                        inputType: EnumQuestionType.INPUT,
                        questSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 6,
                        title: "Gender",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Male", "Female", "Diverse"],
                        divider: true
                    },
                    {
                        number: 7,
                        title: "Does the person have a job?",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Yes", "No", "Unknown"]
                    },
                    {
                        number: 8,
                        title: "What is the person's occupation?*",
                        inputType: EnumQuestionType.INPUT,
                        answer: EmptyAnswer(),
                        hidden: true,
                        divider: true
                    },
                    {
                        number: 9,
                        title: "Is there occupational disability due to illness?*",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.MEDIUM,
                        answer: EmptyAnswer(),
                        data: ["Yes", "No"],
                        hidden: true,
                        divider: true
                    },
                    {
                        number: 10,
                        title: "How is the patient insured?",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.MEDIUM,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Statutory health insurance", "The patient pays for the medication themselves"]
                    },
                    {
                        number: 11,
                        title: "Will the insurance cover the costs of medical cannabis?",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Yes", "No", "Unknown"],
                        divider: true
                    },
                    {
                        number: 12,
                        title: "Why are the costs of therapy not covered by insurance?*",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        hidden: true,
                        answer: EmptyAnswer(),
                        data: ["Rejection of application", "No application submitted", "In process", freeTextInput],
                        divider: true
                    },
                    {
                        number: 13,
                        title: "How was treatment with medical cannabis initiated?*",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.MEDIUM,
                        answer: EmptyAnswer(),
                        data: ["Physician", "By patient"]
                    },
                    {
                        number: 14,
                        title: "Was there any experience with cannabis prior to the doctor's prescription?*",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.MEDIUM,
                        answer: EmptyAnswer(),
                        data: ["Yes", "No"]
                    },
                    {
                        number: 15,
                        title: "Is there substance abuse? (Multiple selections possible)*",
                        inputType: EnumQuestionType.DROPDOWN,
                        multiple: true,
                        answer: EmptyAnswer(),
                        data: ["No information", "Alcohol", "Benzodiazepines", "Cannabis", "Hallucinogens", "Nicotine", "Opioids", "Psychostimulants"]
                    }
                ]
            }
        ]
    },
    {
        number: 3,
        stepper: "Symptom pattern",
        title: "Symptom pattern",
        description: "Information on the indication for treatment with medical cannabis",
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "Please select one symptom pattern to narrow down the indication for treatment.",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Pain", "Spasticity", "Neurological disorder", "Psychiatric disorder", "Cancer", "Gastrointestinal disorder", "Other"],
                        conditionalOptions: {
                            dependedKey: "Indikation"
                        }
                    },
                    {
                        number: 2,
                        title: "Please state the indication for treatment.",
                        description: "(Only one answer is possible here. Information about other coexisting conditions will be requested below.)",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        required: true,
                        answer: EmptyAnswer(),
                        data: [],
                        conditionalOptions: {
                            dependedKey: "Indikation",
                            options: IndikationOptions
                        }
                    },
                    {
                        number: 3,
                        title: "How long has the condition existed?",
                        inputType: EnumQuestionType.MONTH,
                        inputSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 4,
                        title: "For what reason are or were cannabis medicinal products used as medicinal therapy for this indication? (Multiple answers possible)",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        required: true,
                        multiple: true,
                        answer: EmptyAnswer(),
                        data: [
                            "Medical cannabis is part of the guideline-based treatment for this indication",
                            "Guideline-based treatment has been or has been exhausted (e.g., maximum dosage reached without sufficient therapeutic effect)",
                            "Guideline-based treatment caused/caused intolerable side effects",
                            "Contraindications to certain medications in the guideline-based treatment exist or existed",
                            "Cannabis medications complement guideline-based treatment in the treatment of other symptoms",
                            freeTextInput
                        ]
                    },
                    {
                        number: 5,
                        title: 'Other diagnoses:',
                        inputType: EnumQuestionType.ICD10SEARCH,
                        icdCode: {
                            popupTitle: "Other diagnoses",
                            buttonText: "ICD10 search"
                        },
                        answer: EmptyAnswer()
                    },
                    {
                        number: 6,
                        title: "Brief medical history related to the indication for treatment with cannabis medications",
                        placeholder: `Example: "Spondylodesis 11/2018 for progressive instability L3/4, right gonarthrosis, obesity (BMI 32), IDDM, chronic pain, and insufficient pain therapy with opioids with pronounced side effects (constipation, dizziness with risk of falls)."`,
                        inputType: EnumQuestionType.TEXTAREA,
                        required: true,
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    },
    {
        number: 4,
        stepper: "Symptom Treatment",
        title: "Symptoms",
        description: "Within the context of the indication you specified above, one or more symptoms are usually treated with cannabis medication. First, select the relevant symptoms that will be treated with CAM. In the next step, you can evaluate the change in each symptom.",
        subSections: [
            {
                number: 1,
                title: "Symptom Selection",
                description: "Please select the relevant symptoms that will be treated with CAM as part of the therapy. You can also add any other symptoms you consider relevant using free text.",
                required: true,
                symptomeObj: {
                    dependedByThis: ISymptomeName.SymptomAuswahl
                },
                questions: [
                    {
                        number: 1,
                        title: "<strong>Painful symptoms</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Chronic pain", "Neuropathic pain", "Musculoskeletal pain", "Migraine"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 2,
                        title: "<strong>Psychological symptoms</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Stress and/or tension", "Sleep disturbances", "Anxiety", "Restlessness", "Depression", "Hyperactivity"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 3,
                        title: "<strong>Physical symptoms</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Nausea/vomiting", "Seizures", "Spasticity/spastic paralysis", "Loss of appetite/weight loss", "Diarrhea", "Chronic inflammation"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 4,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        extraOption: {
                            buttonText: "Other symptoms",
                            multiple: true
                        },
                        data: [],
                        answer: EmptyAnswer()
                    }
                ]
            },
            {
                number: 2,
                title: "Impact of symptoms on quality of life",
                description: `Please indicate the extent to which the symptom negatively affects quality of life.<br/>
                    (0 = <strong>no negative</strong> impact on quality of life - 10 = <strong>greatest negative</strong> impact on quality of life)`,
                sectionType: EnumSectionType.SYMPTOMES,
                symptomeObj: {
                    dependedToThis: ISymptomeName.SymptomAuswahl,
                    symptomes: []
                },
                questions: []
            }
        ]
    },
    {
        number: 5,
        stepper: "Drug Therapy",
        title: "Drug therapies (except medical cannabis)",
        description: "What other medications were used for the above-mentioned indication at the time MC therapy was started?",
        subSections: [
            {
                number: 1,
                questions: [],
                sectionType: EnumSectionType.MEDIKAMENT,
                medikamentObj: {
                    medikamentName: EnumMedikamentName.MedikamentTherapie,
                    addMore: "Other Medications",
                    required: true,
                    responseData: [GenereateMedikamentRes(), GenereateMedikamentRes(), GenereateMedikamentRes()],
                    medikament: {
                        title: "Therapy",
                        label: "Drug",
                        inputType: EnumQuestionType.INPUT,
                        required: true
                    },
                    darreichungsform: {
                        label: "Dosage Form",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: ["orally", "intravenously", "transdermal", "subcutaneous", "sublingual", "by inhalation", freeTextInput],
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        }
                    },
                    vorTherapie: {
                        title: "Before starting MC therapy",
                        label: "Daily dosage",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: ["High", "Medium", "Low", "Not used"]
                    },
                    unterTherapie: {
                        title: "During MC therapy",
                        label: "Daily dosage",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: ["High", "Medium", "Low", "Discontinued"]
                    }
                }
            }
        ]
    },
    {
        number: 6,
        stepper: "Non-Drug Therapy",
        title: "Non-Drug Therapies",
        description: "What non-drug therapies were used for the above-mentioned indication at the time MC therapy was started?",
        subSections: [
            {
                number: 1,
                questions: [],
                sectionType: EnumSectionType.MEDIKAMENT,
                medikamentObj: {
                    medikamentName: EnumMedikamentName.NichtTherapie,
                    addMore: "Other non-drug therapies",
                    required: false,
                    responseData: [GenereateNichtRes(), GenereateNichtRes(), GenereateNichtRes()],
                    medikament: {
                        title: "Non-drug therapy",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        options: [
                            "Acupuncture",
                            "Physical therapy",
                            "Rehabilitation sports and functional training",
                            "Relaxation techniques (progressive muscle relaxation)",
                            "Occupational therapy/Ergotherapy",
                            "Interferential current therapy (IFC)",
                            "Kinesio taping",
                            "Shortwave diathermy",
                            "Laser therapy",
                            "Magnetic field therapy",
                            "Manual therapy (manipulation/mobilization)",
                            "Massage",
                            "Percutaneous electrical nerve stimulation (PENS)",
                            "Back therapy training",
                            "Thermotherapy (heat therapy/cold therapy)",
                            "Traction within physical therapy",
                            "Transcutaneous electrical nerve stimulation (TENS)",
                            "Therapeutic ultrasound",
                            "Behavioral therapy",
                            freeTextInput
                        ]
                    },
                    vorTherapie: {
                        title: "Before starting MC therapy",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: [
                            "Therapy was not used before starting MC therapy",
                            "Regular use (successful)",
                            "Regular use (unsuccessful)",
                            "Therapy was used but discontinued (unsuccessful)",
                            "Therapy successfully completed"
                        ]
                    },
                    unterTherapie: {
                        title: "During MC therapy",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: [
                            "Regular use (successful)",
                            "Regular use (unsuccessful)",
                            "Therapy was successfully completed",
                            "Therapy had to be discontinued without success",
                            "Therapy could be initiated during MC therapy",
                            "No use during MC therapy"

                        ]
                    }
                }
            }
        ]
    },
    {
        number: 7,
        stepper: "MC therapy",
        title: "",
        subSections: [
            {
                number: 1,
                title: "Therapy with medical cannabis",
                description: "Are MCs being used at the time of the observation of this case study?",
                questions: [
                    {
                        number: 1,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer(),
                        data: ["Yes", "No"],
                        required: true
                    }
                ]
            },
            {
                number: 2,
                title: "Have medical cannabis medications been discontinued?",
                questions: [
                    {
                        number: 1,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer(),
                        data: ["Yes", "No"],
                        required: true
                    }
                ]
            }
        ]
    },
    {
        number: 8,
        stepper: "Side effects of MC therapy",
        title: "Side effects of medical cannabis",
        description: "Please select the side effects that occurred during MC therapy.",
        subSections: [
            {
                number: 1,
                title: "Side Effects Selection",
                required: true,
                symptomeObj: {
                    dependedByThis: ISymptomeName.NebenwirkungenAuswahl
                },
                questions: [
                    {
                        number: 1,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: [KeineNebenwirkungen_EN],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 2,
                        title: "<strong>Psychische Nebenwirkungen</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Drowsiness/Fatigue", "Dizziness/Balance Disturbance", "Memory Impairment", "Unwanted Euphoria", "Difficulty Concentrating/Attention-Difficulty", "Disorientation", "Lethargy", "Depression", "Hallucinogenic Illusions and/or Delusions"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 3,
                        title: "<strong>Körperliche Nebenwirkungen</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Dry Mouth", "Nausea and/or Vomiting", "Unwanted Weight Gain", "Red Eyes", "Increased Appetite", "Cardiovascular Disorders (Palpitations/Tachycardia/Hypotension)", "Blurred Vision", "Gastrointestinal Discomfort (Diarrhea or Constipation)"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 4,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        extraOption: {
                            buttonText: "Other side effects",
                            multiple: true
                        },
                        data: [],
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    },
    {
        number: 9,
        stepper: "Summary",
        title: "Summary",
        description: "Change in quality of life and conclusion of medical cannabis therapy",
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "In your opinion, how has therapy with medical cannabis affected the patient's quality of life?",
                        placeholder: "(-5 = strong negative impact - 0 = no impact +5 = strong positive impact)",
                        inputType: EnumQuestionType.POSNEGSLIDER,
                        required: true,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 2,
                        title: "Your experience with treatment:<br/> Compared to the patient's baseline condition, this patient's condition has improved.",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        divider: true,
                        extraClass: {
                            question: 'mt-3'
                        },
                        data: [
                            "Significantly improved",
                            "Improved",
                            "Slightly improved",
                            "No change",
                            "Slightly worsened",
                            "Worsened",
                            "Significantly worsened"
                        ],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 3,
                        title: "General comments regarding medical cannabis therapy",
                        placeholder: "Please provide a general summary of the MC therapy in this case. What went particularly well, or were there any difficulties regarding the selection of the MC type or dosage? How do you rate the therapy overall? Do you have any recommendations for colleagues? Thank you!",
                        inputType: EnumQuestionType.TEXTAREA,
                        required: true,
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    },
    {
        number: 10,
        stepper: "End data entry",
        title: "End data entry",
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "Please enter your email address",
                        inputType: EnumQuestionType.INPUT,
                        pattern: emailPattern,
                        required: true,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 2,
                        title: "Please repeat your email address",
                        lastInfo: `
<p><strong>Why are we asking for your email address?</strong></p>
<p>Our scientific team will review and approve the case you have submitted. We will then notify you by email once the causality is published. If we have any further questions, we will also contact you by email. We strive to process and publish individual cases as quickly as possible. The email address will not be presented upon publication of the case.</p>
<p>The incoming forms will be reviewed by our scientific team led by Prof. Dr. Thomas Herdegen and André Ihlenfeld. If you have further questions about the use of the data, please click on the FAQ section.</p>
`,
                        extraClass: {
                            question: 'dateneingabe-beenden'
                        },
                        inputType: EnumQuestionType.INPUT,
                        pattern: emailPattern,
                        required: true,
                        answer: EmptyAnswer(),
                        validateValueWith: {
                            sectionNumber: 10,
                            subSectionNumber: 1,
                            questionNumber: 1
                        }
                    },
                    {
                        number: 3,
                        title: "<strong>If you have received a personal code from a PEP partner, please enter it here:</strong>",
                        inputType: EnumQuestionType.INPUT,
                        inputSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    }
]
